module.exports = __webpack_public_path__ + "static/ddtsi-hagerman-id-3b0ac570d3c5b3c7c9d85e536e57dee5.png";